import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-934d5d9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "claiming-amount" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "claiming-amount__info" }
const _hoisted_4 = { class: "claiming-amount__info-amount" }

import { Token } from "@/types/token";
import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'claiming-amount',
  props: {
  token: {
    type: Object as PropType<Token>,
    default: null,
  },
  amount: {
    type: Number,
    default: 0,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: "claiming-amount__icon",
      src: __props.token.image
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h3", _hoisted_4, [
        _createTextVNode(_toDisplayString(_ctx.$filters.cryptoCurrencyFormat(__props.amount)) + " ", 1),
        _createElementVNode("span", null, _toDisplayString(__props.token.symbol), 1)
      ])
    ])
  ]))
}
}

})